import React, { Fragment } from 'react'
import { CategoryMenu } from './CategoryMenu'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import { OnlyCash } from './OnlyCash'

const MainMenu = ({ categoryMenu, onlyCash, catalogJustCash }) => {
  (function () {
    setTimeout(() => {
      var linkMenu = document.querySelectorAll('button.link-menu')
      Array.from(linkMenu).forEach(link => {
        link.addEventListener('click', function (event) {
          let containClass = false
          if (link.classList.contains('link-menu-active')) {
            containClass = true
          }
          Array.from(linkMenu).forEach(linkToRemove => {
            linkToRemove.classList.remove('link-menu-active')
            linkToRemove.setAttribute('aria-expanded', false)
          })
          if (!containClass) {
            link.classList.add('link-menu-active')
            link.setAttribute('aria-expanded', true)
          }
          event.preventDefault()
        })
        link.addEventListener('blur', function (event) {
          setTimeout(() => {
            let itemSelected = document.querySelectorAll('button.link-menu.link-menu-active ~ .submenu .link-profile:focus').length > 0
            if (!itemSelected) {
              Array.from(linkMenu).forEach(linkToRemove => {
                linkToRemove.classList.remove('link-menu-active')
                linkToRemove.setAttribute('aria-expanded', false)
              })
            }
          }, 300)
        })
      })
      var linkSubmenu = document.querySelectorAll('button.link-menu ~ .submenu .link-profile')
      Array.from(linkSubmenu).forEach(link => {
        link.addEventListener('blur', function (event) {
          setTimeout(() => {
            let itemSelected = document.querySelectorAll('button.link-menu.link-menu-active ~ .submenu .link-profile:focus').length > 0
            if (!itemSelected) {
              Array.from(linkMenu).forEach(linkToRemove => {
                linkToRemove.classList.remove('link-menu-active')
                linkToRemove.setAttribute('aria-expanded', false)
              })
            }
          }, 300)
        })
      })
    }, 500)
  })()

  return (
    <Fragment>
      <nav
        className='container-menu zindex-medium pos-relative bg-brand-4 container-fluid d-none d-md-block d-print-none' aria-label='Menu Principal'
      >
        <div className='container'>
          <div className='menu menu-without-trade row row-eq-height flex-wrap flex-md-nowrap'>
            <div className='col'>
              <div className='row'>
                <CategoryMenu menus={categoryMenu} onlyCash={onlyCash} />
              </div>
            </div>

            <MediaQuery minDeviceWidth={768}>
              <div className='col-auto'>
                <div className='row'>{catalogJustCash ? <OnlyCash /> : ''}</div>
              </div>
            </MediaQuery>
          </div>
        </div>
      </nav>
    </Fragment>
  )
}

MainMenu.propTypes = {
  categoryMenu: PropTypes.object,
  catalogJustCash: PropTypes.bool,
  onlyCash: PropTypes.any
}

export default MainMenu



// WEBPACK FOOTER //
// ./src/App/MainMenu/MainMenu.js